import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';
import { ShoppingCartFacade } from '@ridango/components/lib/shopping-cart/+state';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-cart-terms',
    templateUrl: './cart-terms.component.html',
})
export class CartTermsComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    termsAgreed$: Observable<boolean>;
    termsUrl$: Observable<string>;

    termsModalVisible = false;

    constructor(private cartFacade: ShoppingCartFacade, private applicationFacade: ApplicationFacade) {}

    ngOnInit() {
        this.termsAgreed$ = this.cartFacade.termsAgreed$;
        this.termsUrl$ = this.applicationFacade.termsUrl$;
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    toggleTermsAgreed() {
        this.termsAgreed$.pipe(take(1), takeUntil(this.componentDestroyed$)).subscribe((isAccepted) => {
            this.cartFacade.setCartAgreement(!isAccepted);
        });
    }

    openTerms() {
        this.termsModalVisible = true;
    }

    closeTerms() {
        this.termsModalVisible = false;
    }

    setTermsAcceptance(status: boolean) {
        this.closeTerms();
        this.cartFacade.setCartAgreement(status);
    }
}
